import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8tnoit8j85: FaireBrandEntity = {
  token: "b_8tnoit8j85",
  type: "brand",
  name: "Mickelberry Gardens",
  avatarUrl:
    "https://cdn.faire.com/fastly/7f08e2b72acc4abd9384007755e23d0213d50799d9dfc8efb06d85cfc7a6186c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8384840446042e3615e1deda5465250e941449c49ef90fc26804313e709c53b0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7f08e2b72acc4abd9384007755e23d0213d50799d9dfc8efb06d85cfc7a6186c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8384840446042e3615e1deda5465250e941449c49ef90fc26804313e709c53b0.png",
  location: "Portland, OR, USA",
  minimumOrderDollars: 75,
  rating: 5,
  reviewCount: 140,
  isTopShop: true,
  isInsider: true,
  description:
    "Mickelberry Gardens offers incredible herbal products inspired by the gifts of the honeybees, designed to be both healing and delicious. \n\nOur mission is to help individuals and families have access to affordable herbal products and increase the empowering practice of self care.\n\nWe manufacture our products at a beautiful, GMP-certified facility located at 12450 NE Marx Street in Portland, Oregon. \n\nOur product line is made with raw honey sourced directly from local beekeepers. We also work directly with several small farmers, who provide the organic medicinal herbs. \n\nWe are a husband and wife team, with a small and dedicated staff who loves what they do. We got our start by keeping bees and formulating our herbal products with herbs grown in our own garden. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:59.773Z",
    importedBy: "entity-db-cli",
  },
};
